import DataTableColumnHeader from '@/components/datatable/DataTableColumnHeader.vue';
import DataTableCurrency from '@/components/datatable/DataTableCurrency.vue';
import VoucherEarlierReleasesTableActions from '@/components/vouchers/VoucherEarlierReleasesTableActions.vue';
import type { Voucher, EconomicDimension } from '@/types';
import { formatDate } from '@/utils/helpers';
import type { ColumnDef } from '@tanstack/vue-table';
import { h } from 'vue';

export function createVoucherEarlierReleasesColumns(dimensions: EconomicDimension[]): ColumnDef<Voucher>[] {
    const enabledDimensions = dimensions.filter(d => d.is_active && d.is_enabled);
    
    return [
    {
        accessorKey: 'Date',
        header: ({ column }) =>
            h(DataTableColumnHeader, {
                column: column,
                title: 'vouchers.voucher_table.date',
            }),
        cell: ({ row }) => {
            return formatDate(row.original.Date);
        },
        filterFn: 'dateRange',
        meta: {
            filterType: 'dateRange',
        },
    },
    {
        accessorKey: 'VoucherNumber',
        header: ({ column }) =>
            h(DataTableColumnHeader, {
                column: column,
                title: 'vouchers.voucher_table.voucher',
            }),
        meta: {
            filterType: 'number',
        },
    },
    {
        accessorKey: 'Text',
        header: ({ column }) =>
            h(DataTableColumnHeader, {
                column: column,
                title: 'vouchers.voucher_table.text',
            }),
    },
    {
        accessorKey: 'Amount',
        header: ({ column }) =>
            h(DataTableColumnHeader, {
                column: column,
                title: 'vouchers.voucher_table.amount',
            }),
        cell: ({ row }) => {
            return h(DataTableCurrency, {
                value: row.original.Amount,
            });
        },
        meta: {
            filterType: 'number',
        },
    },
    {
        accessorKey: 'Account',
        header: ({ column }) =>
            h(DataTableColumnHeader, {
                column: column,
                title: 'vouchers.voucher_table.account',
            }),
    },
    {
        accessorKey: 'ContraAccount',
        header: ({ column }) =>
            h(DataTableColumnHeader, {
                column: column,
                title: 'vouchers.voucher_table.contra_account',
            }),
    },
    {
        accessorKey: 'assigned_names',
        header: ({ column }) =>
            h(DataTableColumnHeader, {
                column: column,
                title: 'vouchers.voucher_table.assigned_to',
            }),
    },
    {
        accessorKey: 'project',
        header: ({ column }) =>
            h(DataTableColumnHeader, {
                column: column,
                title: 'vouchers.voucher_table.project',
            }),
    },
    {
        accessorKey: 'card_number',
        header: ({ column }) =>
            h(DataTableColumnHeader, {
                column: column,
                title: 'vouchers.voucher_table.card',
            }),
    },
    {
        accessorKey: 'department_name',
        header: ({ column }) =>
            h(DataTableColumnHeader, {
                column: column,
                title: 'vouchers.voucher_table.department',
            }),
    },
    // Dynamic dimension columns
    ...enabledDimensions.map((dimension): ColumnDef<Voucher> => ({
        accessorKey: `dimension_${dimension.id}`,
        header: ({ column }) =>
            h(DataTableColumnHeader, {
                column: column,
                title: dimension.name,
            }),
        filterFn: 'arrIncludesSome',
        meta: {
            filterType: 'checkbox',
        },
    })),
    {
        accessorKey: 'comment',
        header: ({ column }) =>
            h(DataTableColumnHeader, {
                column: column,
                title: 'vouchers.voucher_table.comment',
            }),
    },
    {
        id: 'actions',
        enableHiding: false,
        header: ({ column }) =>
            h(DataTableColumnHeader, {
                column: column,
                title: 'tables.actions',
            }),
        cell: ({ row }) => {
            return h(VoucherEarlierReleasesTableActions, {
                voucher: row.original,
            });
        },
    },
    ];
}

export const columns = createVoucherEarlierReleasesColumns([]);
